// src/environments/environment.prod.ts

export const environment: string = 'prod';

export const urls = {
  api: 'https://auth-app-api.cdc-iot.com'
};



// WEBPACK FOOTER //
// ./src/environments/environment.prod.ts